import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { GetSearchResultQuery } from '../gql/graphql';

const getSearchResult = graphql(/* GraphQL */ `
  query getSearchResult(
    $destinationId: Int!
    $month: Int!
    $numberOfDiver: Int!
    $year: Int!
    $searchType: Int!
  ) {
    tripWithCriteria(
      request: {
        destinationId: $destinationId
        month: $month
        numberOfDiver: $numberOfDiver
        year: $year
        searchType: $searchType
      }
    ) {
      boatId
      boatName
      availabilityDetails {
        routeName
        embarkationDate
        disEmbarkationDate
        price
        currency
        numberOfDay
        numberOfNight
        numberOfDive
        tripId
        routeId
        totalAvailability
      }
      boatFacilities {
        boatId
        name
        sort
        facilityGroupId
        iconName
      }
      boatPhotos {
        boatId
        imageUrl
      }
    }
  }
`);

const useGetSearchResult = (
  destinationId: number,
  month: number,
  numberOfDiver: number,
  year: number,
  searchType: number,
  enabled: boolean = true,
) => {
  const { data, isLoading } = useQuery<GetSearchResultQuery>({
    queryKey: [
      'tripWithCriteria',
      destinationId,
      month,
      numberOfDiver,
      year,
      searchType,
    ],
    queryFn: async () =>
      graphqlRequest<GetSearchResultQuery>(getSearchResult, {
        destinationId: destinationId,
        month: month,
        numberOfDiver: numberOfDiver,
        year: year,
        searchType: searchType,
      }), // Public endpoint, no auth needed
    enabled: enabled,
    retry: shouldRetryQuery,
  });

  return {
    searchResult: data,
    searchResultLoading: isLoading,
  };
};

export default useGetSearchResult;
